<template>
  <section class="table">
    <el-table
      ref="TableRef" :data="tableData" max-height="550" border highlight-current-row
      @current-change="currentChange" @selection-change="selectionChange" @expand-change="expandChange">
      <el-table-column type="selection" width="40" v-if="showSelection"></el-table-column>
      <template v-for="(x1,i1) in tableItemsShow">
        <!-- <el-table-column type="expand">
          <template slot-scope="props">
            <div class="expanded-box">
              <el-button size="mini" plain type="primary" @click="refreshCallsClick(props.row)">刷新通话记录</el-button>
              <el-table class="call-table" :data="props.row.calls" max-height="550" border highlight-current-row>
                
                <el-table-column label="操作" width="360" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" plain type="primary" @click="editCallsClick(scope.row,props.row)">编辑</el-button>
                    <el-button size="mini" plain type="success" @click="downloadCallsClick(scope.row.id)">下载通话文件</el-button>
                    <el-button size="mini" plain type="success" @click="viewCallsTextClick(scope.row.voiceTextList)">查看通话文本</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip v-for="(x2,i2) in tableHeards" :key="i2"
                  :prop="x2.key" :label="x2.label" align="center" width="144"></el-table-column>

              </el-table>
              <Pagenation :pageData="props.row.pageData" @pageChange="e=>pageChange2(e,props.row)"></Pagenation>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column
          :prop="x1.key" :label="x1.label"
          :fixed="(i1===0&&fixedFirst)||x1.fixed||false" :align="x1.align||'center'"
          :min-width="x1.width||widthDefault+22"
          show-overflow-tooltip>
          <template slot-scope="scope">

            <template v-if="x1.tType==='xy_file'">
              <p class="file-item">
                <span class="file-name">{{scope.row[x1.key].fileName}}</span>
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+scope.row[x1.key].fileId" target="_blank">
                  <el-button size="mini" plain type="success">预览</el-button>
                </a>
                <a :download="scope.row[x1.key].fileName" :href="puUrl_x+'/'+scope.row[x1.key].fileId" target="_blank" style="margin-left:10px;">
                  <el-button size="mini" plain type="primary">下载</el-button>
                </a>
              </p>
            </template>

            <template v-else-if="x1.tType==='xy_files'">
              <p v-for="(x2,i2) in scope.row[x1.key]" :key="i2" class="file-item">
                <span class="file-name">{{x2.fileName}}</span>
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src='+puUrl_x+'/'+x2.fileId" target="_blank">
                  <el-button size="mini" plain type="success">预览</el-button>
                </a>
                <a :download="x2.fileName" :href="puUrl_x+'/'+x2.fileId" target="_blank" style="margin-left:10px;">
                  <el-button size="mini" plain type="primary">下载</el-button>
                </a>
              </p>
            </template>

            <template v-else-if="x1.tType==='xy_phone'">
              <template v-if="scope.row[x1.key]&&(x1.disabled||x1.tDisabled)">
                <div style="height:28px;line-height:28px;" v-if="x1.phoneShow&&x1.phoneShow(scope.row)">{{ scope.row[x1.key] }}</div>
                <div style="height:28px;line-height:28px;" v-else>{{ scope.row[x1.key]|toHidePhone }}</div>
              </template>
              <div v-else-if="!x1.disabled&&!x1.tDisabled">
                <el-tooltip effect="dark" :content="scope.row[x1.key]" placement="top" popper-class="custom-tooltip">
                  <el-input
                    size="mini" v-model="scope.row[x1.key]" clearable
                    :placeholder="x1.placeholder" style="margin-bottom: 4px;"
                    :class="x1.class||''" :style="x1.style||rowStyle" />
                </el-tooltip>
              </div>
              <el-button
                size="mini" plain type="success" :disabled="!scope.row[x1.key]"
                @click="callClick(scope.row[x1.key],scope.row.id)" v-if="scope.row[x1.key]">呼叫</el-button>
            </template>

            <template v-else>
              <FormItem :x1="x1" :row="scope.row" typeKey="t" />
            </template>
          </template>
        </el-table-column>

      </template>

      <el-table-column label="操作" :width="actionBarWidth" align="center" fixed="right" @click.stop.prevent="()=>{}" v-if="$scopedSlots.actionBar">
        <template slot-scope="scope">
          <slot name="actionBar" :row="scope.row" />
        </template>
      </el-table-column>

    </el-table>
    <Pagenation :pageData="pageData" @pageChange="pageChange" />
  </section>
</template>

<script>
import Pagenation from '@/components/Pagenation'
import FormItem from '@/components/XY/FormItem'
export default {
  components: { Pagenation, FormItem },
  props: {
    formItems: { type: Array, default: () => [] },
    tableData: { type: Array, default: () => [] },
    currentChange: { type: Function, default: () => {} },
    selectionChange: { type: Function, default: () => {} },
    expandChange: { type: Function, default: () => {} },
    callClick: { type: Function, default: () => {} },
    actionBarWidth: { type: String, default: '240' },
    pageData: { type: Object, default: () => {} },
    pageChange: { type: Function, default: () => {} },
    showSelection: { type: Boolean, default: true },
    fixedFirst: { type: Boolean, default: false },
  },
  data() {
    return {
      widthDefault: 130,
    }
  },
  computed: {
    rowStyle() {
      return `width:${this.widthDefault}px;`
    },
    tableItemsShow() {
      return this.formItems.filter(x1 => !x1.tHide && x1.tShow).sort((a, b) => a['tIndex'] - b['tIndex'])
    },
  },
}
</script>

<style lang='scss' scoped>
.file-item{height: 40px;line-height: 40px;display: flex;}
.file-name{
  display: inline-block;min-width: 120px;max-width: 200px;padding: 0 10px;
  overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
}
</style>